import clsx from 'clsx';
import React from 'react';

import styles from './styles.module.css';

type ButtonProps = {
  customStyles?: string;
  linkUrl: string;
  svgIcon?: string;
  text: string;
};

const ForumGhostButton = ({ customStyles, linkUrl, svgIcon, text }: ButtonProps) => {
  return (
    <a href={linkUrl} className={clsx(styles.ForumGhostButton, customStyles)}>
      <img height={16} width={16} src={svgIcon} />
      {text}
    </a>
  );
};

export default ForumGhostButton;
